import React from 'react';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import classes from './ExportToExcel.module.css';
import exportIcon from '../../../assets/icons/export.svg';
import { useTranslation } from '../../../hooks/useTranslations';

export interface ISalesOrderExport {
  sales_order_id: number;
  external_id: number;
  customer_first_name: string;
  customer_last_name: string;
  total: number | undefined;
  subtotal_amount: number | undefined;
  voucher_amount: number | undefined;
  vat: number;
  currency: string;
  booking_date: Date | string;
  appointment_date: Date | string;
  payment_method?: string;
  paid?: string;
}

export interface IDiagnosticReportsExport {
  sales_order_id: number;
  last_name: string;
  first_name: string;
  status?: string;
  service_name: string;
  booking_date: string;
  result: string;
  sample_id: string;
}
export interface IVideoConsultingReportsExport {
  sales_order_id: number;
  last_name: string;
  first_name: string;
  status: string;
  service_name: string;
  booking_date: string;
}

export interface ICustomerExport {
  person_id: number | undefined;
  person_firstname: string;
  person_lastname: string;
  gender?: string;
  person_birthdate: Date | any;
  person_email: string;
  person_mobile_phone: string;
  street: string;
  house_number: string;
  city: string;
  postcode: number;
  country?: string;
}

type Props = {
  apiData:
    | ISalesOrderExport[]
    | IDiagnosticReportsExport[]
    | IVideoConsultingReportsExport[]
    | ICustomerExport[];
  fileName: string;
};

export const ExportToExcel: React.FC<Props> = ({ apiData, fileName }) => {
  const { translations } = useTranslation();
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const exportToCSV = (
    dataToExport:
      | ISalesOrderExport[]
      | IDiagnosticReportsExport[]
      | IVideoConsultingReportsExport[]
      | ICustomerExport[],
    fileName: string
  ) => {
    const transformedData = dataToExport.map((item: any) => {
      const transformedItem: any = {};
      Object.keys(item).forEach((key) => {
        const translatedKey = translations(key) || key;
        transformedItem[translatedKey] = item[key];
      });
      return transformedItem;
    });

    const ws = XLSX.utils.json_to_sheet(transformedData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <div className={classes.container}>
      <button
        className={classes.button}
        onClick={(e) => exportToCSV(apiData, `healthpoint_attachment_${new Date().getTime()}`)}
      >
        <div>{translations('export')}</div>
        <img className={classes.icon} src={exportIcon} alt={'globe'} />
      </button>
    </div>
  );
};
